import { render } from "./Doughnut.vue?vue&type=template&id=554b27bc&scoped=true"
import script from "./Doughnut.vue?vue&type=script&lang=js"
export * from "./Doughnut.vue?vue&type=script&lang=js"

import "./Doughnut.vue?vue&type=style&index=0&id=554b27bc&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554b27bc"]])

export default __exports__